export type WatermarkKind = 'game' | 'casino-screenshot';

/**
 * Build URL for server-side watermarked image generation.
 * Returned URL points to our API, so downloaded files include watermark.
 */
export function getWatermarkedImageUrl(src: string, kind: WatermarkKind): string {
  const raw = String(src ?? '').trim();
  if (!raw) return raw;
  if (raw.includes('/api/images/watermark?')) return raw;
  return `/api/images/watermark?kind=${encodeURIComponent(kind)}&src=${encodeURIComponent(raw)}`;
}

